module.exports = __webpack_public_path__ + "static/media/kitchen-living_dark.95b3e955.jpg";